import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Team } from '../../../pages/team/Team';

export const Route = createFileRoute('/_private/_home/team')({
  component: TeamRoute,
});

function TeamRoute() {
  const { apiClient } = Route.useRouteContext();
  return <Team portalApiClient={apiClient} />;
}
